import { render, staticRenderFns } from "./AdminMyProfile.vue?vue&type=template&id=083fc9ba&"
import script from "./AdminMyProfile.vue?vue&type=script&lang=ts&"
export * from "./AdminMyProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AdminMyProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports